export const tickToTimeStamp = (ticks) => {
  const epochDiff = 62135596800000
  const ms = Math.floor(ticks / 10000)
  return ms - epochDiff
}
